/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.ui

import org.jetbrains.compose.resources.StringResource

/**
 * Converts a [Throwable] into a user-friendly [UiText], falling back
 * to [fallback] when the exception has no useful message.
 */
fun Throwable.toUiText(fallback: StringResource): UiText =
    message?.let { UiText.Dynamic(it) } ?: UiText.Resource(fallback)
